module.exports = __webpack_public_path__ + "static/media/error-de-localizacion.3ae54e12.png";